import { AddAmendmentPopup } from 'features/ContractDetails/Facilities/AddAmendment/Popup'
import { HSTable } from 'features/ContractDetails/Facilities/HSTable/HSTable'
import { useHSTable } from 'features/ContractDetails/Facilities/hooks/useHSTable'
import HSTableProvider from 'features/ContractDetails/Facilities/Providers/HSTableProvider'
import { getContractHealthSystems } from 'features/ContractDetails/Facilities/api'
import { columnsShortView, onboardedHsColumns } from './HSTable/constants'
import { useContractDetailsContext } from 'features/ContractDetails/Providers/ContractDetailsContextProvider'
import { useMemo } from 'react'
import cn from 'classnames'

const Facilities = () => {
  const {
    state: { isOnboarded, canSeeLoPSignatories, canSeeHealthSystem }
  } = useContractDetailsContext()
  const hsTableProps = useHSTable({ getContractHealthSystems })

  const columns = useMemo(() => {
    return isOnboarded
      ? onboardedHsColumns(canSeeLoPSignatories, canSeeHealthSystem)
      : columnsShortView(canSeeLoPSignatories, canSeeHealthSystem)
  }, [isOnboarded, canSeeLoPSignatories, canSeeHealthSystem])

  return (
    <HSTableProvider {...hsTableProps}>
      <div
        className={cn('contract-hs-list', {
          'contract-hs-list__short-view': isOnboarded
        })}
      >
        <HSTable columns={columns} {...hsTableProps} />
      </div>
      <AddAmendmentPopup />
    </HSTableProvider>
  )
}

export default Facilities
